module.exports = __webpack_public_path__ + "resource/img/devices.9246741c.jpeg";